// Modal.js
import React from "react";
import "./Modal.css";

const Modal = ({ isOpen, onClose, project }) => {
  if (!isOpen || !project) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{project.title}</h2>
          <button onClick={onClose} className="close-btn">✖</button>
        </div>

        <div className="modal-body">
          <p>{project.description}</p>
          <hr />

          {/* ✅ Show website preview if available */}
          {project.website && project.previewImage && (
            <div className="preview-box">
              <p className="section-label">Live Website</p>
              <a href={project.website} target="_blank" rel="noopener noreferrer">
                <img src={project.previewImage} alt={`${project.title} preview`} />
              </a>
            </div>
          )}

          {/* ✅ Embed Figma prototype */}
          {project.figma && (
            <div className="preview-box">
              <p className="section-label">Figma Prototype</p>
              <iframe
           title={`${project.title} Figma preview`}
  src={project.figma}
  allowFullScreen
  style={{
    width: "100%",
    height: "80vh",       // take 80% of viewport height
    border: "1px solid #ccc",
    borderRadius: "8px",
  }}
></iframe>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
